import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/noNewFriend.png'


const _withScopeId = n => (_pushScopeId("data-v-a02910b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "list"
}
const _hoisted_2 = { class: "itemList" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "right" }
const _hoisted_6 = { class: "namebox" }
const _hoisted_7 = { class: "nickname van-ellipsis" }
const _hoisted_8 = { class: "hellomsg" }
const _hoisted_9 = {
  key: 1,
  class: "notype"
}
const _hoisted_10 = {
  key: 2,
  class: "notype"
}
const _hoisted_11 = {
  key: 1,
  class: "nodata"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1 /* HOISTED */))
const _hoisted_13 = { class: "title" }
const _hoisted_14 = { class: "subtitle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_nav_bar, {
      title: $setup.t('im.newFriend'),
      "left-arrow": "",
      fixed: "",
      "safe-area-inset-top": "",
      onClickLeft: $setup.onClickLeft
    }, null, 8 /* PROPS */, ["title"]),
    ($setup.newFriendData.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.newFriendData, (item) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_van_image, {
                  fit: "cover",
                  round: "",
                  width: "50",
                  height: "50",
                  src: item.info.headurl
                }, null, 8 /* PROPS */, ["src"]),
                (item.info.usertype == 1)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: $setup.zbtype,
                      alt: ""
                    }, null, 8 /* PROPS */, _hoisted_4))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(item.info.nickname), 1 /* TEXT */),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('im.subitFriend')), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(item.hellomsg), 1 /* TEXT */)
                ]),
                _createElementVNode("div", null, [
                  (item.applyState == 0)
                    ? (_openBlock(), _createBlock(_component_van_button, {
                        key: 0,
                        type: "success",
                        round: "",
                        color: "#0D0D0D",
                        size: "small",
                        onClick: ($event: any) => ($setup.friendApply(item, 1)),
                        style: {"padding":"3px 20px"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('im.pass')), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
                    : _createCommentVNode("v-if", true),
                  _createCommentVNode(" <van-button type=\"danger\" size=\"small\" v-if=\"item.applyState == 0\" @click=\"friendApply(item, 2)\"\n                        style=\"margin-left:5px\">拒绝</van-button> "),
                  (item.applyState == 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t('im.agree')), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  (item.applyState == 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$t('im.reject')), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ])
              ])
            ]))
          }), 256 /* UNKEYED_FRAGMENT */))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('noData.noNewfriend')), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('tips.tosendhd')), 1 /* TEXT */)
        ]))
  ], 64 /* STABLE_FRAGMENT */))
}